import React from 'react';
import { Advertorial } from './components/Advertorial';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <style jsx global data-id="element-1">{`
        .sticky-cta {
          width: 100%;
          max-width: 300px;
        }
        .sticky-cta-inner {
          background: white;
          border-radius: 0.5rem;
          padding: 1.25rem;
          box-shadow:
            0 4px 6px -1px rgba(0, 0, 0, 0.1),
            0 2px 4px -1px rgba(0, 0, 0, 0.06);
          border: 1px solid #e5e7eb;
        }
        @media (max-width: 1023px) {
          .sticky-cta {
            max-width: 100%;
            margin: 0 auto;
          }
        }
      `}</style>
      <Advertorial data-id="element-2" />
    </div>;
}